import { render, staticRenderFns } from "./anew.vue?vue&type=template&id=2d4f5975&scoped=true"
import script from "./anew.vue?vue&type=script&lang=js"
export * from "./anew.vue?vue&type=script&lang=js"
import style0 from "./anew.vue?vue&type=style&index=0&id=2d4f5975&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4f5975",
  null
  
)

export default component.exports